import {
    Action,
    createReducer,
    on
} from '@ngrx/store';
import {
    datiqLogAdapter,
    initialState,
    State,
} from './datiq-log.models';
import * as DatiqLogActions from './datiq-log.actions';
import * as DatiqLogReducerUtils from './datiq-log-reducer-utils';

const datiqLogReducer = createReducer(
    initialState,
    on(
        DatiqLogActions.log,
        (state, { message, info }: { message: string; info?: unknown }) =>
            datiqLogAdapter.addOne(
                DatiqLogReducerUtils.makeInfoEntity(message, info),
                { ...state }
            )
    ),
    on(
        DatiqLogActions.warn,
        (state, { message, info }: { message: string; info?: unknown }) =>
            datiqLogAdapter.addOne(
                DatiqLogReducerUtils.makeWarningEntity(message, info),
                { ...state }
            )
    ),
    on(
        DatiqLogActions.jsError,
        (
            state,
            {
                message,
                error,
                info,
            }: { message: string; error: Error; info?: unknown }
        ) =>
            datiqLogAdapter.addOne(
                DatiqLogReducerUtils.makeJsErrorEntity(message, error, info),
                { ...state }
            )
    ),
    on(
        DatiqLogActions.debug,
        (state, { message, info }: { message: string; info?: unknown }) =>
            datiqLogAdapter.addOne(
                DatiqLogReducerUtils.makeDebugEntity(message, info),
                { ...state }
            )
    ),
    on(
        DatiqLogActions.error,
        (state, { message, info }: { message: string; info?: unknown }) =>
            datiqLogAdapter.addOne(
                DatiqLogReducerUtils.makeErrorEntity(message, info),
                { ...state }
            )
    )
);

export function reducer(state: State | undefined, action: Action) {
    return datiqLogReducer(state, action);
}
